import { useCallback, useEffect, useState } from "react";
import MuiProvider from "../utils/muiProvider";
import toast, { Toaster } from "react-hot-toast";
import { DPadController } from "../components/layout/sidebar";
import {
  fetchPublicAuthConfig,
  getClockOffsetMs,
  subscribePublicAuthConfig,
} from "../services/publicAuthConfigService";

export const metadata = {
  title: "منه باخ",
  description: "به منه باخ خوش آمدید",
};

const DEVICE_TIME_ALERT_THRESHOLD_MS = 10 * 60 * 1000;
var hasShownDeviceTimeAlert = false;

function DeviceTimeSync({ onClockUpdate }) {
  useEffect(function () {
    var isMounted = true;

    function handleClockUpdate() {
      if (isMounted) onClockUpdate();

      var diff = Math.abs(getClockOffsetMs());
      if (!hasShownDeviceTimeAlert && diff > DEVICE_TIME_ALERT_THRESHOLD_MS) {
        hasShownDeviceTimeAlert = true;
        toast.error("ساعت دستگاه شما بیش از ۱۰ دقیقه با سرور اختلاف دارد. لطفا ساعت دستگاه را تنظیم کنید.", {
          duration: 10000,
        });
      }
    }

    fetchPublicAuthConfig().then(handleClockUpdate);
    var unsubscribe = subscribePublicAuthConfig(handleClockUpdate);

    return function () {
      isMounted = false;
      unsubscribe();
    };
  }, [onClockUpdate]);

  return null;
}

export default function RootLayout({ children }) {
  const [, setClockRevision] = useState(0);

  const handleClockUpdate = useCallback(function () {
    setClockRevision(function (value) {
      return value + 1;
    });
  }, []);

  return (
    <MuiProvider>
      <Toaster />
      <DeviceTimeSync onClockUpdate={handleClockUpdate} />
      {children}
      <DPadController />
    </MuiProvider>
  );
}
